import { memo, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ArthritisJointPain() {
  useEffect(() => {
    document.title = "Arthritis & Joint Pain Management | Viksha Health Care";

    const newMetaDescription =
      "Arthritis and joint pain management at Viksha Health Care. Evaluation, lifestyle guidance, medicines, injections, and rehabilitation support.";

    let metaTag = document.querySelector('meta[name="description"]');
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "description");
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute("content", newMetaDescription);
  }, []);

  return (
    <>
      {/* Keep if you want hidden keyword heading */}
      <h2 style={{ fontSize: "0px", margin: 0, padding: 0 }}>
        Arthritis & Joint Pain Management
      </h2>

      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage
            src="/photo/Arthritis-Joint-Pain-Management.avif"
            alt="Arthritis and joint pain management"
            loading="lazy"
          />
        </div>

        <div className="textareaofser">
          {/* Visible page heading */}
          <h1>Arthritis &amp; Joint Pain Management</h1>

          <p>
            Arthritis and joint pain can affect daily activities like walking,
            climbing stairs, and lifting objects. Early evaluation and proper
            management can reduce pain, improve mobility, and help you stay
            active.
          </p>

          <h5>How Arthritis Is Evaluated</h5>
          <p>
            Proper evaluation is important to understand the type and severity
            of arthritis. Assessment may include a detailed discussion of
            symptoms, physical examination of the affected joints, and when
            needed, imaging tests such as X-rays or scans. In some cases, blood
            tests may be advised to rule out inflammatory or autoimmune causes.
          </p>

          <h5>Goals of Treatment</h5>
          <ul>
            <li>Reduce joint pain and stiffness</li>
            <li>Improve movement and flexibility</li>
            <li>Slow progression of joint damage</li>
            <li>Help you return to normal daily activities</li>
            <li>Enhance overall quality of life</li>
          </ul>

          <h5>Advanced Non-Surgical Treatment Options</h5>
          <p>
            In addition to basic medications and physiotherapy, some patients
            may benefit from advanced non-surgical treatments designed to
            support joint function and reduce discomfort.
          </p>
          <ul>
            <li>
              Viscosupplementation (lubricating joint injections in selected
              cases)
            </li>
            <li>Regenerative therapies like PRP in appropriate patients</li>
            <li>Bracing or joint support devices for stability</li>
          </ul>

          <h5>Home Care Tips for Joint Pain</h5>
          <ul>
            <li>Apply warm compresses to relieve stiffness</li>
            <li>Use cold packs during flare-ups to reduce swelling</li>
            <li>Avoid prolonged sitting in one position</li>
            <li>Choose low-impact activities like walking or swimming</li>
            <li>Maintain a healthy body weight to reduce joint stress</li>
          </ul>

          <h5>Importance of Early Treatment</h5>
          <p>
            Many people ignore joint pain until it becomes severe. Early
            treatment can slow joint damage, prevent deformity, and reduce the
            need for major surgery later.
          </p>

          <h5>Who Is at Higher Risk?</h5>
          <ul>
            <li>Individuals above 45 years of age</li>
            <li>People with previous joint injuries</li>
            <li>Those with a family history of arthritis</li>
            <li>Overweight or obese individuals</li>
            <li>People with physically demanding occupations</li>
          </ul>

          <h5>When Is Surgery Considered?</h5>
          <p>
            Surgery is usually considered when pain is severe, joint damage is
            advanced, and non-surgical treatments no longer provide relief.
            Joint replacement may improve mobility and reduce pain in carefully
            selected patients.
          </p>

          <h5>Living Well with Arthritis</h5>
          <p>
            Arthritis does not have to control your life. With the right
            combination of medical care, exercise, weight management, and
            lifestyle adjustments, many people continue to live active and
            independent lives.
          </p>

          <p>
            If joint pain is limiting your movement or affecting your daily
            routine, a timely orthopedic consultation can help you understand
            your condition and explore the most suitable treatment options.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(ArthritisJointPain);
